import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'newTemplate',
  props: ['tipoFluxo'],

  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      id: null,
      editar: false,
      formSearch: {
        descricao: '',
        pes: '',
        codigo: '',
        revisao: 0
      },
      dataNewTemplate: {}
    }
  },
  mounted () {
  },
  methods: {
    popUptAdd () {
      this.formSearch.descricao = ''
      this.formSearch.pes = ''
      this.formSearch.codigo = ''
      this.formSearch.revisao = 0
      this.id = null
      this.$refs['add-novo-template'].show()
    },
    popUptEdicao (dados) {
      this.editar = true
      this.formSearch.descricao = dados.itemAvaliacao
      this.formSearch.pes = dados.codPes
      this.id = dados.id
      this.formSearch.codigo = dados.codigoTemplate
      this.formSearch.revisao = dados.revisao != null ? dados.revisao : 0
      this.$refs['add-novo-template'].show()
    },
    fecharPopUptAdd () {
      this.$refs['add-novo-template'].hide()
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    verificaCampos () {
      loading.push()
      if (this.formSearch.descricao === '') {
        loading.pop()
        return toast.warning('O campo ITEM AVALIAÇÃO deve ser preenchido')
      }
      if (this.tipoFluxo === 'PIVS') {
        if (this.formSearch.pes === '') {
          loading.pop()
          return toast.warning('O campo CÓDIGO PES deve ser preenchido')
        }
      }
      if (this.formSearch.revisao === '' || this.formSearch.revisao === null || isNaN(this.formSearch.revisao)) {
        loading.pop()
        return toast.warning('O campo REVISÃO deve ser preenchido com um número')
      }
      if (this.editar === false) {
        this.postCriarTemplateWeb()
      } else {
        this.postEditarTemplateWeb()
      }
    },
    postCriarTemplateWeb () {
      qmaTemplate.CriarNovoTemplateWeb({DescricaoItemAvaliacao: this.formSearch.descricao, CodigoPES: this.formSearch.pes, Fluxo: this.tipoFluxo === 'PIVS' ? 2 : this.tipoFluxo === 'LV' ? 0 : 1, Codigo: this.formSearch.codigo, Revisao: this.formSearch.revisao})
        .then((Response) => {
          this.formSearch.descricao = ''
          this.formSearch.pes = ''
          this.codigo = ''
          loading.pop()
          this.dataNewTemplate = Response.data
          this.$emit('recarregarTable', true)
          this.fecharPopUptAdd()
        })
        .catch(Error => {
          loading.pop()
          toast.warning('Dados incorretos, falha ao cadastrar')
        })
    },
    postEditarTemplateWeb () {
      qmaTemplate.editarTemplateQMA({DescricaoItemAvaliacao: this.formSearch.descricao, CodigoPES: this.formSearch.pes, Fluxo: this.tipoFluxo === 'PIVS' ? 2 : this.tipoFluxo === 'LV' ? 0 : 1, Codigo: this.formSearch.codigo, TemplateId: this.id, Revisao: this.formSearch.revisao})
        .then((Response) => {
          this.formSearch.descricao = ''
          this.formSearch.pes = ''
          this.codigo = ''
          loading.pop()
          this.$emit('recarregarTable', true)
          this.fecharPopUptAdd()
        })
        .catch(Error => {
          loading.pop()
          toast.warning('Dados incorretos, falha ao editar')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/newTemplate/newTemplate.js